import { preferredStartPath } from './startPage';
import jwtDecode from "jwt-decode";
import { APP_IDS, getOwningAppIdForPath } from '../runtime/appProfile';

const TOKEN_KEY = "token";

// Decoding is only for client session state; the API still verifies signatures.
export const decodeSessionToken = (token) => {
  if (typeof token !== "string" || token.split(".").length !== 3) return null;
  try {
    const decoded = jwtDecode(token);
    if (!decoded || typeof decoded !== "object" || Array.isArray(decoded)) return null;
    if (Number(decoded.userId) <= 0 || !Number.isFinite(Number(decoded.userId))) return null;
    if (decoded.exp != null && (!Number.isFinite(Number(decoded.exp)) || Number(decoded.exp) <= Date.now() / 1000)) return null;
    return decoded;
  } catch (_error) {
    return null;
  }
};

export const getToken = () => {
  try {
    const sessionToken = sessionStorage.getItem(TOKEN_KEY);
    if (decodeSessionToken(sessionToken)) {
      // Ensure existing logged-in sessions also persist across tabs/windows.
      localStorage.setItem(TOKEN_KEY, sessionToken);
      return sessionToken;
    }
    sessionStorage.removeItem(TOKEN_KEY);
  } catch (_err) {
    // ignore
  }

  // Legacy fallback + migration from localStorage to sessionStorage
  try {
    const legacyToken = localStorage.getItem(TOKEN_KEY);
    if (decodeSessionToken(legacyToken)) {
      sessionStorage.setItem(TOKEN_KEY, legacyToken);
      return legacyToken;
    }
    localStorage.removeItem(TOKEN_KEY);
  } catch (_err) {
    // ignore
  }

  return null;
};

export const setToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
      // Persist to localStorage too so auth survives tab/window changes.
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch (_err) {
    // ignore storage failures
  }
};

export const getDecodedToken = () => {
  return decodeSessionToken(getToken());
};
export function getSafeReturnTo(raw) {
  if (!raw) return null;

  try {
    // Support absolute or relative values. Enforce same origin.
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) return null; // prevent open redirect
    const pathname = decodeURIComponent(url.pathname);
    if (getOwningAppIdForPath(pathname) === APP_IDS.PLANY_CARE) return null;
    if (['/login', '/signup', '/forgotpassword'].includes(pathname)) return null;
    const vertical = url.searchParams.get('v');
    if (vertical && vertical !== 'booking') return null;
    // Keep only the path + query + hash
    return url.pathname + url.search + url.hash;
  } catch {
    // If it's a plain relative path like "/x", accept it; otherwise drop it
    return null;
  }
}

export function getLoginDestination(user, ...candidates) {
  return candidates.map(getSafeReturnTo).find(Boolean) || preferredStartPath(user) ||
    (user?.defaultBusinessId ? '/biz/bookingtypes?v=booking' : '/workspaces');
}
